import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useFormState } from "react-final-form";

import "../styles/components/EstimateLoader.scss";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const EstimateLoader = () => {
  const {
    values: { firstname },
  } = useFormState();

  const messages = [
    `One moment, ${firstname}...`,
    "Surveys can be in person, virtually or online!",
    "Over 1 Million Families moved!",
    "Expert moving packing & storage",
    "Trusted mover for over 90 Years",
  ];

  const [message, setMessage] = useState("");
  const [reverse, setReverse] = useState(false);

  const getMessage = async (index) => {
    setMessage("");
    await sleep(200);
    if (messages[index]) {
      setMessage(messages[index]);
      await sleep(2500);
      getMessage(index + 1);
    } else {
      setReverse(true);
      await sleep(200);
      setMessage("Nearly there...");
    }
  };

  useEffect(() => {
    getMessage(0);
  }, []);

  return (
    <AnimatePresence initial={false}>
      <motion.div
        className="estimateLoader"
        initial={{ opacity: 0, y: 50, scale: 0.3 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      >
        <div className={`estimateLoader__progress ${reverse && "reverse"}`}>
          <div className="estimateLoader__messages">
            <AnimatePresence initial={false}>
              {message && (
                <motion.div
                  positionTransition
                  initial={{ opacity: 0, y: 50, scale: 0.3 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{
                    opacity: 0,
                    scale: 0.5,
                    transition: { duration: 0.2 },
                  }}
                >
                  {message}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div className="estimateLoader__progress-width" />
        </div>
      </motion.div>{" "}
    </AnimatePresence>
  );
};

export default EstimateLoader;
